<script>
import { videoMethods, workoutComputed, orgComputed, orgMethods } from '@/src/state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...workoutComputed,
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    },
  },
  mounted() {},
  methods: {
    ...videoMethods,
    ...orgMethods,
    hide() {
      this.$bvModal.hide('tips-modal');
      this.setVideoAction('play');
    },
  },
};
</script>

<template>
  <b-modal id="tips-modal" centered :hide-footer="true" :hide-header="true" size="lg" no-stacking>
    <div class="tips-container">
      <h1 class="title" :style="colors">Tips</h1>
      <template v-if="currentExercise && currentExercise.tips.length">
        <ul class="list-tips">
          <li v-for="(tip, i) in currentExercise.tips" :key="i" :style="colors">
            <span class="tips-text">{{ tip }}</span>
          </li>
        </ul>
      </template>
      <template v-else>
        [No Tips Placeholder]
      </template>
    </div>
    <BaseButton class="button btn-primary large" @click="hide">
      Close
    </BaseButton>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .modal-dialog {
  max-width: 700px !important;
  min-width: 20%;

  .modal-content {
    background: white;
    border-radius: $base-border-radius-md;
    box-shadow: 0 0 3px rgba(171, 171, 171, 0.5);

    .modal-body {
      height: 45vh;
      padding-bottom: 4rem;

      @include media('xxl', null) {
        margin-top: 3.9rem;
      }

      .tips-container {
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: scroll;

        .title {
          color: var(--color);
          font-size: 26.78px;
          font-style: normal;
          font-weight: bold;
          line-height: 3.7rem;
          text-align: center;
          text-transform: capitalize;
        }

        .list-tips li {
          background: rgba(var(--color), 0.1);
          border-radius: 8px;
          padding: 1.6rem;
          text-align: center;

          &:not(:last-child) {
            margin-bottom: 0.8rem;
          }

          .tips-text {
            font-size: 1.4rem;
            font-style: normal;
            font-weight: normal;
            line-height: 1.8rem;
            mix-blend-mode: normal;
            opacity: 0.9;
            text-align: center;
          }
        }
      }

      .btn-primary {
        bottom: -3rem;
        position: absolute;
        width: 60%;
      }
    }
  }
}
</style>
